const INVOICES_URL = `${process.env.API_V4_HOST}/invoices`;

export const getInvoice = ($axios, invoiceId) => $axios.$get(`${INVOICES_URL}/${invoiceId}`);
export const getInvoices = ($axios, params) => $axios.$get(`${INVOICES_URL}`, { params });
